import React from 'react';
import { ShieldCheck, Lock, ListChecks } from 'lucide-react';
import { getRoleInfo } from '../config/permissionConfig';

export default function RoleResponsibilityCard({ roleName, roleLabel, isBeingConfigured = false }) {
  if (!roleName) return null;

  const role = getRoleInfo(roleName);
  const modules = Array.isArray(role.modules) ? role.modules : [];

  return (
    <div className="rounded-2xl border border-rose-200 bg-gradient-to-br from-rose-50 via-white to-amber-50 p-5 shadow-sm">
      <div className="mb-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <ShieldCheck size={18} className="text-rose-600" />
          <h3 className="text-sm font-semibold text-rose-700">Role Responsibility</h3>
        </div>
        {isBeingConfigured ? (
          <span className="rounded-full bg-rose-100 px-3 py-1 text-xs font-semibold text-rose-700">
            Currently configuring
          </span>
        ) : null}
      </div>

      <p className="text-sm font-semibold text-slate-900">{roleLabel || role.label}</p>
      <p className="mt-2 text-sm leading-6 text-slate-700">{role.note || 'No role summary available.'}</p>

      <div className="mt-4 grid gap-3 md:grid-cols-2">
        <div className="rounded-xl border border-slate-200 bg-white p-3">
          <div className="mb-2 flex items-center gap-2 text-slate-800">
            <ListChecks size={16} className="text-cyan-700" />
            <p className="text-xs font-semibold uppercase tracking-wide">Usually works in</p>
          </div>
          <div className="flex flex-wrap gap-2">
            {modules.length > 0 ? (
              modules.map((moduleName) => (
                <span
                  key={moduleName}
                  className="rounded-full border border-cyan-200 bg-cyan-50 px-2.5 py-1 text-xs font-medium text-cyan-800"
                >
                  {moduleName}
                </span>
              ))
            ) : (
              <span className="text-xs text-slate-500">No modules listed.</span>
            )}
          </div>
        </div>

        <div className="rounded-xl border border-slate-200 bg-white p-3">
          <div className="mb-2 flex items-center gap-2 text-slate-800">
            <Lock size={16} className="text-amber-700" />
            <p className="text-xs font-semibold uppercase tracking-wide">Permission authority</p>
          </div>
          <p className="text-sm text-slate-700">
            {role.managed_by
              ? `Allowed or blocked by: ${role.managed_by}`
              : 'Top authority role. Not managed by another role.'}
          </p>
        </div>
      </div>
    </div>
  );
}
